const uppercaseNonAbbreviation = /^\p{Uppercase_Letter}\P{Uppercase_Letter}/u

/**
 * Lowercase first letter of text, handling abbreviations as well as possible.
 *
 * @example
 * ```ts
 * toInlineSafe('Some value')
 * // -> 'some value'
 * toInlineSafe('ABC value')
 * // -> 'ABC value'
 * ```
 */
export const toInlineSafe = (text: string) => {
	if (uppercaseNonAbbreviation.test(text)) {
		return text[0].toLowerCase() + text.substring(1)
	}
	return text
}
